(function () {
    const product_slider_v2_list = document.querySelectorAll(
        ".js_product_slider_v2"
    );
    for (let i = 0; i < product_slider_v2_list.length; i++) {
        const slider = product_slider_v2_list[i];
        initProductSliderV2(slider);

        handleEqualHeightOnContentElements(slider);
    }

    function initProductSliderV2(slider) {
        const sliderWrapEl = slider.closest(".product-slider-sec");
        const swiperPagination =
            sliderWrapEl.querySelector(".swiper-pagination");
        const swiperButtonNext = sliderWrapEl.querySelector(
            ".swiper-button-next"
        );
        const swiperButtonPrev = sliderWrapEl.querySelector(
            ".swiper-button-prev"
        );

        const slideCount = slider.querySelectorAll(".swiper-slide").length;
        const activeSlidesPerView = window.innerWidth >= 1200 ? 3 : window.innerWidth >= 992 ? 2 : 1;

        let sliderOptions = {
            spaceBetween: 40,
            slidesPerView: 1,
            // centeredSlides: true,
            loop: slideCount > activeSlidesPerView,
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 992px
                992: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                1200: {
                    slidesPerView: slideCount >= 3 ? 3 : 2,
                    spaceBetween: 40,
                }
            },
            pagination: {
                el: swiperPagination,
                clickable: true,
                dynamicBullets: false,
            },
            navigation: {
                nextEl: swiperButtonNext,
                prevEl: swiperButtonPrev,
            },
        };

        new Swiper(slider, sliderOptions);
    }

    function handleEqualHeightOnContentElements(slider) {
        const _contents = slider.querySelectorAll(".slide-card__footer .inner");
        if (window.innerWidth > 992) {
            setEqualHeightOnContentElements(_contents);

            window.addEventListener("resize", () =>
                handleEqualHeightOnContentElements(slider)
            );
        } else {
            _contents.forEach((content) => {
                content.children[0].style.height = "initial";
                content.children[1].style.height = "initial";
            });
        }
    }

    function setEqualHeightOnContentElements(contents) {
        if (contents) {
            let _titleMaxHeight = 0;
            let _textMaxHeight = 0;

            contents.forEach((content) => {
                if (content.children[0]) content.children[0].style.height = "";
                if (content.children[1]) content.children[1].style.height = "";

                _titleMaxHeight = getElementMaxHeight(
                    content.children[0]?.children[0],
                    _titleMaxHeight
                );
                _textMaxHeight = getElementMaxHeight(
                    content.children[1]?.children[0],
                    _textMaxHeight
                );
            });

            contents.forEach((content) => {
                if (content.children[0]) content.children[0].style.height = _titleMaxHeight + "px";
                if (content.children[1]) content.children[1].style.height = _textMaxHeight + "px";
            });
        }
    }

    function getElementMaxHeight(el, elMaxHeight) {
        if (el && el.offsetHeight > elMaxHeight) {
            elMaxHeight = el.offsetHeight;
        }

        return elMaxHeight;
    }
})();
